(() => {
  const instances = new WeakMap();
  function bind(header) {
    if (instances.has(header)) return;
    const lifecycle = new AbortController();
    const options = { signal: lifecycle.signal };
    const sheet = header.querySelector('.roads-sheet');
    const opener = header.querySelector('[data-roads-open]');
    const close = sheet.querySelector('[data-roads-close]');
    const branches = [...header.querySelectorAll('.roads-branch')];
    const desktop = matchMedia('(min-width:980px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const audiencePicker = header.querySelector('[data-roads-audience]');
    function syncAudience() {
      if (!audiencePicker) return;
      const api = window.PlaytimeAudience;
      const audience = api?.read().audience || 'him';
      const selected = ['him', 'her'].includes(audience) ? audience : 'all';
      audiencePicker.dataset.selected = selected;
      audiencePicker.querySelector('[data-roads-audience-current]').setAttribute('aria-label', audiencePicker.dataset['label' + selected[0].toUpperCase() + selected.slice(1)]);
      for (const choice of audiencePicker.querySelectorAll('[data-roads-audience-choice]')) {
        const value = choice.dataset.roadsAudienceChoice;
        const destination = new URL(location.href);
        destination.searchParams.set('pt_aud', value);
        for (const parameter of ['pt_hub', 'pt_mode', 'page']) destination.searchParams.delete(parameter);
        if (destination.searchParams.has('filter.p.m.custom.audience')) {
          destination.searchParams.set('filter.p.m.custom.audience', value === 'her' ? 'For Her' : 'For Him');
        }
        choice.href = (api?.catalogueURL(destination) || destination).href;
        if (audience === value) choice.setAttribute('aria-current', 'true');
        else choice.removeAttribute('aria-current');
      }
    }
    syncAudience();
    document.addEventListener('playtime:audience', syncAudience, options);
    let animation;
    const finish = () => {
      animation?.cancel();
      animation = null;
      if (sheet.open) sheet.close();
    };
    const closeSheet = () => {
      if (!sheet.open) return;
      animation?.cancel();
      if (reduced.matches || !sheet.animate) return finish();
      animation = sheet.animate([{ transform:'translateX(0)' }, { transform:'translateX(-100%)' }], { duration:210, easing:'ease-in' });
      animation.onfinish = finish;
    };
    function closeBranches(except) {
      for (const branch of branches) if (branch !== except) branch.open = false;
    }
    opener.addEventListener('click', () => {
      closeBranches();
      sheet.showModal();
      opener.setAttribute('aria-expanded','true');
      close.focus({ preventScroll:true });
      if (!reduced.matches && sheet.animate) animation = sheet.animate([{ transform:'translateX(-100%)' }, { transform:'translateX(0)' }], { duration:210, easing:'ease-out' });
    }, options);
    close.addEventListener('click', closeSheet, options);
    sheet.addEventListener('cancel', event => { event.preventDefault(); closeSheet(); }, options);
    sheet.addEventListener('close', () => {
      opener.setAttribute('aria-expanded','false');
      if (!desktop.matches && header.isConnected) opener.focus({ preventScroll:true });
    }, options);
    sheet.addEventListener('click', event => { if (event.target === sheet && event.clientX > sheet.getBoundingClientRect().right) closeSheet(); }, options);
    for (const branch of branches) {
      branch.addEventListener('toggle', () => { if (branch.open) closeBranches(branch); }, options);
      branch.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !branch.open) return;
        event.preventDefault();
        branch.open = false;
        branch.querySelector('summary').focus({ preventScroll:true });
      }, options);
      branch.addEventListener('focusout', event => {
        if (event.relatedTarget && !branch.contains(event.relatedTarget)) branch.open = false;
      }, options);
    }
    document.addEventListener('pointerdown', event => {
      const branch = event.target.closest('.roads-branch');
      closeBranches(branch && header.contains(branch) ? branch : null);
    }, options);
    desktop.addEventListener('change', () => { closeBranches(); if (desktop.matches) finish(); }, options);
    window.addEventListener('pageshow', () => { closeBranches(); finish(); }, options);
    instances.set(header, () => { lifecycle.abort(); finish(); });
  }
  function init(root) { root.querySelectorAll('[data-roads-header]').forEach(bind); }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const header of event.target.querySelectorAll('[data-roads-header]')) { instances.get(header)?.(); instances.delete(header); } });
})();
